var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.5 103",
    width: 59,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 9px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#fff",
    className: "d",
    x: 4.5,
    y: 4.5,
    width: 159.5,
    height: 94,
    rx: 6,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    className: "d",
    d: "M84.25,64.5L4.5,10.5c0-1.66,.62-3.16,1.63-4.24s2.4-1.76,3.93-1.76H158.44c1.54,0,2.93,.67,3.93,1.76s1.63,2.59,1.63,4.24l-79.75,54Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.677efd6fd48b0e0d8abb7b7c92facd33.svg";
export { ForwardRef as ReactComponent };